// https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
// https://javascript.plainenglish.io/use-constructor-in-react-functional-component-with-custom-hooks-e0770e92b840
// https://blog.csdn.net/qq_20567691/article/details/106035547

import {useEffect,useState,useMemo,useContext} from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar ,IonBackButton,IonButtons,IonIcon,IonItem,IonButton,

  IonLabel,IonInput,IonSelect,IonSelectOption,
  IonDatetime,
  useIonToast,
  IonCheckbox,
  IonTextarea,
  IonSplitPane,
  IonList,
  IonMenu
} from '@ionic/react';

import './ConfigEdit2.css';

import {useRestGetTextFile,restPutTextFile, restPatch} from "../hooks/AdminHttp";

// const ini = require('ini');
import {parse, stringify} from 'ini';
import { stat } from 'fs';
import SplitLayout from '../components/SplitLayout';
import { resolvePtr } from 'dns';
const configmeta = require('../config_meta.json')


interface Json {[key:string]:any};

const ConfigEdit2: React.FC<{
  meta:Json,
  field:string,
  item:Json,
  role:string,
  entities:Json,
  splitPaneEnabled:boolean,
  setSplitPaneEnabled:any,
  onCloseClicked:()=>void
}> = ({meta,field, item,role,entities,splitPaneEnabled,setSplitPaneEnabled, onCloseClicked}) => {

  let fieldMeta = meta.fields[field ];

  const [state,setState] = useState<{[key:string]:any}>(item?item:{});

  const [toastPresent,toastDismiss] = useIonToast();

  const [content,getContent] = useRestGetTextFile(fieldMeta.edit_get_path + 'config/' + item[field]);


  useEffect(()=>{
    
    getContent({
      filetype:'config',
      suffix:'ini',
      role:role
    });

  },[]);

  useEffect(()=>{
    
    // console.log("content: " + content);

    const config = parse(content);

    setState({...state, menu_items: Object.keys (config).map((k:string)=>{
      console.log(k);
      let m = configmeta[k ];

      m['key'] = k;
      return m;

    }),config:config });


  },[content]);


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>

          <IonTitle>编辑{meta.name}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onCloseClicked}>取消</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent >

      <SplitLayout>
          <IonContent>
          <IonList id="inbox-list">
              {
                state.menu_items && state.menu_items.map((item:any)=><IonItem  key={item.key} lines='none' button={true} onClick={()=>{
                  setState({...state, key:item.key , section: state.config[item.key]});
                }}>
                <IonLabel style={state.key==item.key?{fontWeight:'normal',color:'#1e88e5'}:  {fontWeight:'normal'}}>{item.label}</IonLabel>
              </IonItem>)
              }

          </IonList>
          </IonContent>
        <IonContent>
           <IonList>   
          {state.section && Object.keys(state.section).map(
            (k)=><IonItem  key={k}>
              <IonLabel style={{width:'64px',color:'gray'}}>{k}</IonLabel>
              <IonInput value={state.section[k]} style={{width:'128px'}} placeholder="Enter text" onIonChange={(e)=>{
                state.section[k] = e.detail.value;
                setState({
                  ...state
                });
              }}></IonInput>
              <IonLabel style={{color:'gray'}}>{configmeta[state.key].options[k].label}</IonLabel>
            </IonItem>

          ) 

          }


      </IonList>
        </IonContent>
    </SplitLayout>

      {/* <IonSplitPane contentId="main" style={{
          "--side-width":"224px",
          "--side-min-width":"192px",
          "padding-top":"44px",
          "height":"1300px"
        }}>
          
          <IonMenu contentId="main" style={{
            "width":"120px"
          }}>
          <IonHeader>
            <IonToolbar color="tertiary">
              <IonTitle>Menu</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent class="ion-padding">

            <IonList id="inbox-list">
              {
                state.menu_items && state.menu_items.map((item:any)=><IonItem >
                <IonLabel>{item.label}</IonLabel>
              </IonItem>)
              }

            </IonList>

          </IonContent>
          </IonMenu>


          <IonTextarea autoGrow={true} value={state.content?state.content:content  } onIonChange={e =>{
              if (e )
              setState({...state, content: e.detail.value});
          }}  />

        </IonSplitPane> */}


      

      </IonContent>


      <IonItem lines="none">
          <IonButton slot="end"  size="default" color="secondary" expand="block" fill="solid" onClick={()=>{

              let content = stringify(state.config);

              restPutTextFile(fieldMeta.edit_put_path + 'config/' + item[field] ,{
                filetype:'config',
                suffix:'ini',
                role:role
              },content,(resp:any)=>{
                console.log('resp: ' + resp);

                if (resp.filename){


                  console.log('resp filename:' + resp.filename);

                  restPatch(meta.patch_path + '/' + item.uuid + '/' + field + ',md5' ,{"filename": resp.filename, "md5": resp.md5},(resp:any)=>{
                    console.log('resp: ' + resp);
                    toastPresent({
                      message:"提交成功", 
                      duration: 3000,
                      color:'success' 
                    });
      

                    toastPresent({
                      message:"提交成功", 
                      duration: 3000,
                      color:'success' 
                    });
      
                    onCloseClicked();
      
                  },(msg:any)=>{
                    toastPresent({
                      message:msg, 
                      duration: 3000,
                      color:'danger' 
                    });
                  });


                }else{
                  toastPresent({
                    message:"failed.", 
                    duration: 3000,
                    color:'danger' 
                  });
                }
                

  
              },(msg:any)=>{
                toastPresent({
                  message:msg, 
                  duration: 3000,
                  color:'danger' 
                });
              });
            
          }} >确认</IonButton>
      </IonItem>

    </IonPage>
  );
};


export default ConfigEdit2;